export enum SessionStorageKey {
	DashboardCameraPrivacy = '[SessionStorageKey] DashboardCameraPrivacy',
	DashboardEyeCareMode = '[SessionStorageKey] DashboardEyeCareMode',
	DashboardMicrophone = '[SessionStorageKey] DashboardMicrophone',
	DashboardInDashboardPage = '[SessionStorageKey] DashboardInDashboardPage',
	DashboardWelcomeText = '[SessionStorageKey] DashboardWelcomeText',
	AvailableUpdates = '[SessionStorageKey] AvailableUpdates',
	SecurityWifiSecurityLocationFlag = '[SessionStorageKey] SecurityWifiSecurityLocationFlag',
	SecurityWifiSecurityInWifiPage = '[SessionStorageKey] SecurityWifiSecurityInWifiPage',
	SecurityWifiSecurityInGamingDashboard = '[SessionStorageKey] SecurityWifiSecurityInGamingDashboard',
	SecurityWifiSecurityShowPluginMissingDialog = '[SessionStorageKey] SecurityWifiSecurityShowPluginMissingDialog',
	SecurityWifiSecurityShowHistoryNum = '[SessionStorageKey] SecurityWifiSecurityShowHistoryNum',
	HomeProtectionInCHSPage = '[SessionStorageKey] HomeProtectionInCHSPage',
	SecurityWifiSecurityShowNearbyNum = '[SessionStorageKey] SecurityWifiSecurityShowNearbyNum',
	HomeSecurityShowPluginMissingDialog = '[SessionStorageKey] HomeSecurityShowPluginMissingDialog',
	HomeSecurityShowWelcomeDialog = '[SessionStorageKey] HomeSecurityShowWelcomeDialog',
	HomeSecurityShowLocationPermisisonDialog = '[SessionStorageKey] HomeSecurityShowLocationPermisisonDialog',
	WidgetWifiStatus = '[SessionStorageKey] WidgetWifiStatus',
	ChsLocationDialogNextShowFlag = '[SessionStorageKey] ChsLocationDialogNextShowFlag',
	WarrantyDataCache = '[SessionStorageKey] WarrantyDataCache',
	FirstPageLoaded = '[SessionStorageKey] FirstPageLoaded',
}
